<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <!--<el-menu-item index="1" @click="previewStream()" >-->
        <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
        <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->
      <el-menu-item index="2" @click="toNewRouter('enterprise-big-data')" v-if="permissionCodes.indexOf('026001000') !== -1">
        <i class="el-icon-damai-dashuju"></i>
        <span slot="title">企业数据</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('enterprise-park-data')" v-if="permissionCodes.indexOf('026001000') !== -1">
        <i class="el-icon-damai-qiyedashuju" style="font-size: 22px;"></i>
        <span slot="title">园区企业数据</span>
      </el-menu-item>

      <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div>
    </el-menu>
  </div>
</template>

<script>
  import navMixin from '../../utils/nav'
  import {bus} from '../../utils/bus'

  const indexOfRouterNameEntities = Object.entries({
    '2': ['enterprise-big-data', 'enterprise-big-data-detail'],
    '3': ['enterprise-park-data', 'enterprise-park-data-detail'],
  })

  export default {
    name: 'alarm-nav',
    mixins: [navMixin],
    computed:{
      defaultActiveMenuIndex () {
        const {name: routeName} = this.$route
        const entity = indexOfRouterNameEntities
          .find(([, routeNames]) => {
            if (routeNames instanceof Array) {
              return routeNames.indexOf(routeName) >= 0
            } else {
              return routeNames === routeName
            }
          })
        return entity && entity[0]
      }
    },
    data () {
      return {
        isCollapse: false,
        permissionCodes: '',
        indexOfRouterNameEntities
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
    },
    methods: {
      toNewRouter (name) {
        this.$router.push({
          name: name
        })
      },
      previewStream () {
        window.open(`https://yq.damaiiot.com/dataPage.html#/fire_control_login_without/${bus.global.yqCode}/${bus.global.yqName}/${bus.global.accountCode}/${bus.global.personCode || 'null'}/${bus.global.personName || 'null'}`, '_blank')
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/EnterpriseBigData/EnterpriseBigDataNav.vue